import { Column, FMColumn } from '../model';

import { ShareSelectorCell } from '../components/cells/ShareSelectorCell';
import { ShareSelectorHeader } from '../components/cells/ShareSelectorHeader';

import { Type } from '../../../../general/modules/filter/dataModel';
export const shareSelectorCol: FMColumn<Type.NONE> = {
  key: Column.selector,
  dataKey: Column.selector,
  title: '',
  width: 50,
  // Закреплена слева — как и обычный `selectorCol`, вместо которого она
  // подставляется на шаренных папках.
  fixed: 'left',
  sortable: false,
  cellRenderer: ShareSelectorCell,
  headerRenderer: ShareSelectorHeader,
  className: 'ch-file-manager__cell_share-selector',
  headerClassName: 'ch-file-manager__header-cell_share-selector',
  getter: () => null,
  toDisplayString: () => null,
};
